import { all } from 'redux-saga/effects';
import authSaga from '../../auth/sagas/authSaga';
import wizardSaga from '../../wizard/sagas/wizardSaga';
import dashboardSaga from '../../dashboard/sagas/dashboardSagas';
import usersSaga from '../../users/sagas/usersSagas';
import groupsSaga from '../../groups/sagas/groupsSagas';

/**
 * Start all the sagas
 */
export default function* rootSaga() {
    yield all([
        authSaga(),
        wizardSaga(),
        dashboardSaga(),
        usersSaga(),
        groupsSaga()
    ]);
}
